import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "row", "form"]

  connect() {
    this.sortable = new Sortable(this.listTarget, {
      handle: ".grabbable",
      animation: 150,
      ghostClass: "list-group-item-info",
      forceFallback: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      revertOnSpill: true,
      onEnd: this.reorder.bind(this)
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  reorder() {
    const addresses = this.rowTargets.map((row) => row.dataset.id)

    this.updateForm(addresses)
    // Resequencing clears the HERE times, so their timelines no longer fit the order
    this.element.classList.add("stop-timelines-stale")

    this.rowTargets.forEach((row) => {
      row.classList.remove("alert-danger")
    })
  }

  updateForm(addresses) {
    this.formTarget.querySelectorAll('input[name="route_run[address_sequence][]"]').forEach((input) => input.remove())

    addresses.forEach((address) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "route_run[address_sequence][]"
      input.value = address
      this.formTarget.appendChild(input)
    })

    this.formTarget.requestSubmit()
  }
}
